export const TRIP_STATUS = {
  coming_soon: { label: "Coming Soon", cta: "Join Waitlist", badge: "bg-ink text-cream" },
  waitlist_open: { label: "Waitlist Open", cta: "Join Waitlist", badge: "bg-flame text-white" },
  booking_open: { label: "Booking Open", cta: "Reserve Your Spot", badge: "bg-flame text-white" },
  sold_out: { label: "Sold Out", cta: "Join Next Drop", badge: "bg-cream text-ink" },
  completed: { label: "Completed", cta: "View Trip Recap", badge: "bg-cream/90 text-ink" },
  draft: { label: "Draft", cta: "Join Waitlist", badge: "bg-ink/60 text-cream" },
};

export const EVENT_STATUS = {
  coming_soon: { label: "Coming Soon", cta: "Join Waitlist", badge: "bg-ink text-cream" },
  rsvp_open: { label: "RSVP Open", cta: "RSVP Now", badge: "bg-flame text-white" },
  sold_out: { label: "Sold Out", cta: "Join Waitlist", badge: "bg-cream text-ink" },
  completed: { label: "Completed", cta: "See Recap", badge: "bg-cream/90 text-ink" },
};

export const getStatus = (s) => TRIP_STATUS[s] || TRIP_STATUS.coming_soon;
export const getEventStatus = (s) => EVENT_STATUS[s] || EVENT_STATUS.coming_soon;

// Exact dates only show when admin has entered them — never invented.
export const dateDisplay = (trip) => {
  if (trip.start_date && trip.end_date) return `${trip.start_date} – ${trip.end_date}`;
  if (trip.date_label) return trip.date_label;
  if (trip.dates?.length) return trip.dates.join(" · ");
  return "Dates Coming Soon";
};

// Prices are only shown for trips that are actually open — never for concepts/coming soon.
export const showPrice = (status) => ["waitlist_open", "booking_open", "sold_out"].includes(status);
